export const booleanAttributeTransformer = (value: boolean | ''): boolean => value === '' ? true : value;
